export default "__VITE_ASSET__6330acaa__"